import { DayOfWeekIso } from '@/constants/date/DayOfWeekIso'

// Data Transfer Object for representing a scheduled time block
export default class ScheduleTimeDTO {
  /**
   * @param {string} timeType - The type of time block (e.g., 'OpenStandardHours', 'BreakStandardHours')
   * @param {string} day - The day of the week (e.g., 'monday)
   * @param {string|null} startTime - Start time in HH:mm format (e.g., '09:00')
   * @param {string|null} endTime - End time in HH:mm format (e.g., '15:00')
   */
  constructor(timeType, day, startTime, endTime) {
    this.type = timeType
    this.startTimeLocal = getDateTimeForDay(startTime, day)
    this.endTimeLocal = getDateTimeForDay(endTime, day)
  }
}

/**
 * Adds date, corresponding to the day of the week, to the time we want to schedule
 * Backend expects the date to be in the format 1900-01-0{dayOfWeekInt}T{scheduled time}:00Z
 * Example: getDateTimeForDay('09:00', 'monday') => '1900-01-01T09:00:00Z'
 * @param {string|null} time - Time in HH:mm format or null
 * @param {string} day - Day of the week (e.g., 'monday')
 * @returns {string|null} ISO string or null if time is null
 */
function getDateTimeForDay(time, day) {
  if (time === null) return null
  const key = day.toUpperCase()
  const dayOffset = DayOfWeekIso[key] // (1=Monday, 7=Sunday)

  return `1900-01-0${dayOffset}T${time}:00Z`
}
